import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashProcessingLineItem from "../CashProcessingLineItem";
import ModelProxyClass from "./ModelProxyClass";
import CashCollection from "../CashCollection";
import AmountDetails from "../AmountDetails";
import FileAsset from "../FileAsset";


/**
 * @class CashProcessingLineItemBase
 * @extends ModelBaseClass
 * @property {number} id (int64)
 * @property {number} cashProcessingBatchId (int64)
 * @property {number} cashCollectionId (int64) set if called from access via a cashCollection.cashProcessingLineItem
 * @property {CashCollection} cashCollection set if NOT called from access via a cashCollection.cashProcessingLineItem
 * @property {number} countedAmount
 * @property {AmountDetails} countedDetails
 * @property {number} discrepancyAmount
 * @property {number} handpayAmount
 * @property {string} note
 * @property {FileAsset} meterReceiptFileAsset
 */
class CashProcessingLineItemBase extends ModelBaseClass {
	/**
	 * @type {number} id (int64)
	 */
	id;
	/**
	 * @type {number} cashProcessingBatchId (int64)
	 */
	cashProcessingBatchId;
	/**
	 * set if called from access via a cashCollection.cashProcessingLineItem
	 * @type {number} cashCollectionId (int64)
	 */
	cashCollectionId;
	/**
	 * set if NOT called from access via a cashCollection.cashProcessingLineItem
	 * @type {CashCollection} cashCollection
	 */
	cashCollection;
	/**
	 * @type {number} countedAmount
	 */
	countedAmount;
	/**
	 * @type {AmountDetails} countedDetails
	 */
	countedDetails;
	/**
	 * @type {number} discrepancyAmount
	 */
	discrepancyAmount;
	/**
	 * @type {number} handpayAmount
	 */
	handpayAmount;
	/**
	 * @type {string} note
	 */
	note;
	/**
	 * @type {FileAsset} meterReceiptFileAsset
	 */
	meterReceiptFileAsset;

	/**
	 * Instantiates a new instance of CashProcessingLineItem based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashProcessingLineItem}
	 */
	static create(genericObject) {
		const newCashProcessingLineItem = new CashProcessingLineItem();
		newCashProcessingLineItem.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashProcessingLineItem;
	}

	/**
	 * Instantiates a new array of CashProcessingLineItem based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashProcessingLineItem]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashProcessingLineItemArray = [];
		genericArray.forEach(genericObject => {
			newCashProcessingLineItemArray.push(CashProcessingLineItem.create(genericObject));
		});
		return newCashProcessingLineItemArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('id', 'integer'),
	ModelBaseClass.createModelProperty('cashProcessingBatchId', 'integer'),
	ModelBaseClass.createModelProperty('cashCollectionId', 'integer'),
	ModelBaseClass.createModelProperty('cashCollection', 'CashCollection'),
	ModelBaseClass.createModelProperty('countedAmount', 'float'),
	ModelBaseClass.createModelProperty('countedDetails', 'AmountDetails'),
	ModelBaseClass.createModelProperty('discrepancyAmount', 'float'),
	ModelBaseClass.createModelProperty('handpayAmount', 'float'),
	ModelBaseClass.createModelProperty('note', 'string'),
	ModelBaseClass.createModelProperty('meterReceiptFileAsset', 'FileAsset'),
];

export default CashProcessingLineItemBase;
